// import React from 'react'
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
const OurTeam = () => {
  return (
    <div className="pb_100 xs_pb_70">
    <Container>
      <Row>
        <Col md={12}>
          <div className="section-title common_heading center_heading mb_45">
            {/* <div className="title-header">
              <h3 style={{ width: "max-content", margin: "auto" }}>
                Testimonial
              </h3>
            </div> */}
            <h2 >Our Team</h2>
          </div>
        </Col>
      </Row>
      <Row>
       <Col md={6}>
       <div style={{position:'relative'}} >
        <div>
            <img src="/Images/neeraj-rana.png" alt="" className="our-team-imagess"/>
        </div>
        <div className="our-team-namees">
            <h4>Neeraj Rana</h4>
            <p>Founder</p>
        </div>
       </div>
       </Col>
       <Col md={6}>
       <div style={{position:'relative'}} className="our-team-main-container">
        <div >
            <img src="/Images/monika-rani.png" alt="" className="our-team-imagess" />
        </div>
        <div className="our-team-namees">
            <h4>Monika Rani</h4>
            <p>Co-Founder</p>
        </div>
       </div>
       </Col>
      </Row>
    </Container>
  </div>
  )
}

export default OurTeam